import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  ClearData,
  CloseEditTicket,
  EditTicket,
  GetAssigneesSuccess,
  GetCategoriesSuccess,
  GetCountriesSuccess,
  GetLoyaltySchemaSuccess,
  GetSeveritySuccess,
  GetStatusSuccess,
  OpenTicketNav,
  PanelStatusChanged,
  TicketAssigneeChanged,
  TicketBodyChanged,
  TicketCategoryChanged,
  TicketCountryChanged,
  TicketIDChanged,
  TicketLSChanged,
  TicketSeverityChanged,
  TicketStatusChanged,
  TicketSubjectChanged,
} from '../actions/tickets-search.actions';
import { TicketsSearchState } from '../models/tickets.models';

const initialState: TicketsSearchState = {
  sideNav: false,
  panelExpanded: true,
  ticketId: '',
  ticketSeverityValues: [],
  ticketSeverity: '',
  loyaltySchemaValues: [],
  loyaltySchema: '',
  ticketStatusValues: [],
  ticketStatus: '',
  countryValues: [],
  country: '',
  ticketCategoryValues: [],
  ticketCategory: '',
  ticketAssigneeValues: [],
  ticketAssignee: '',
  body: '',
  subject: '',
};

export const TicketsReducer = createReducer(
  initialState,
  on(GetSeveritySuccess, (state, { res }) => {
    let ticketSeverityValues = [...res];
    ticketSeverityValues.push({
      id: -1,
      description: 'literal.tickets.severity.nostatus',
      deleteFlag: false,
    });

    return {
      ...state,
      ticketSeverityValues,
    };
  }),
  on(GetLoyaltySchemaSuccess, (state, { res }) => ({
    ...state,
    loyaltySchemaValues: res,
  })),
  on(GetStatusSuccess, (state, { res }) => ({
    ...state,
    ticketStatusValues: res,
  })),
  on(GetCountriesSuccess, (state, { res }) => ({
    ...state,
    countryValues: res,
  })),
  on(GetCategoriesSuccess, (state, { res }) => ({
    ...state,
    ticketCategoryValues: res,
  })),
  on(GetAssigneesSuccess, (state, { res }) => {
    let ticketAssigneeValues = [...res];
    ticketAssigneeValues.push({
      id: -1,
      description: 'literal.tickets.noassignee',
      deleteFlag: false,
    });

    return {
      ...state,
      ticketAssigneeValues,
    };
  }),
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(TicketIDChanged, (state, { ticketId }) => ({
    ...state,
    ticketId,
  })),
  on(TicketSeverityChanged, (state, { ticketSeverity }) => ({
    ...state,
    ticketSeverity,
  })),
  on(TicketLSChanged, (state, { loyaltySchema }) => ({
    ...state,
    loyaltySchema,
  })),
  on(TicketStatusChanged, (state, { ticketStatus }) => ({
    ...state,
    ticketStatus,
  })),
  on(TicketCountryChanged, (state, { country }) => ({
    ...state,
    country,
  })),
  on(TicketCategoryChanged, (state, { ticketCategory }) => ({
    ...state,
    ticketCategory,
  })),
  on(TicketAssigneeChanged, (state, { ticketAssignee }) => ({
    ...state,
    ticketAssignee,
  })),
  on(TicketBodyChanged, (state, { body }) => ({
    ...state,
    body,
  })),
  on(TicketSubjectChanged, (state, { subject }) => ({
    ...state,
    subject,
  })),
  on(EditTicket, OpenTicketNav, (state) => ({
    ...state,
    sideNav: true,
  })),
  on(CloseEditTicket, (state) => ({
    ...state,
    sideNav: false,
  })),
  on(ClearData, ActiveComponentChanged, (state) => ({
    ...state,
    sideNav: false,
    panelExpanded: true,
    ticketId: '',
    ticketSeverity: '',
    loyaltySchema: '',
    ticketStatus: '',
    country: '',
    ticketCategory: '',
    ticketAssignee: '',
    body: '',
    subject: '',
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
